export default "__VITE_ASSET__Cr88ObEl__"